import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

import SyncIcon from "@mui/icons-material/Sync";
import DefaultApiService from "../../../../../infrastructure/api/default";
import LoadingWrapper from "../../../../components/shared/loading";
import NoDataContainer from "../../../../components/shared/no-data";

const InitializePage = () => {
  const pageInfo = useGetPageInfo();
  const [loading, setLoading] = useState(false);

  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [stepsLoading, setStepsLoading] = useState(false);

  const onFetchData = debounce(async () => {
    try {
      setLoading(true);
      const result = await DefaultApiService.getListApi(
        "BI/Administration/Initialize"
      );
      console.log("result", result);
      if (result?.data?.length) {
        onIntCallApis(result.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, 500);

  useEffect(() => {
    onFetchData();
  }, []);

  const onIntCallApis = async (data) => {
    try {
      setStepsLoading(true);
      const list = data.map((x) => ({
        ...x,
        loading: false,
        status: "منتظر تست",
      }));

      list[0].loading = true;
      list[0].status = "درحال تست";

      setSteps(list);

      let faultPreviewsApi = false;
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        try {
          if (!faultPreviewsApi) {
            item.loading = true;
            item.status = "درحال تست";

            const res = await DefaultApiService.getApi(item.url);
            console.log("res", res);

            if (res?.isSuccess) {
              item.loading = false;
              item.status = "موفقیت آمیز";
              setActiveStep(i + 1);
              setSteps(list);
            } else {
              throw res;
            }
          } else {
            throw new Error({ message: "error" });
          }
        } catch (error) {
          item.loading = false;
          item.status = "خطایی رخ داد.";
          faultPreviewsApi = true;
        }
      }
      setStepsLoading(false);
    } catch (error) {
      setStepsLoading(false);
    }
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                  disabled={stepsLoading}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                {loading ? (
                  <LoadingWrapper />
                ) : steps.length ? (
                  <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((step, index) => (
                      <Step key={step.label}>
                        <StepLabel
                          optional={
                            <Typography variant="caption">
                              {step.status}
                            </Typography>
                          }
                        >
                          {step.title || "بدون عنوان"}
                        </StepLabel>

                        <StepContent>
                          {step.loading ? (
                            <LoadingWrapper my={2} />
                          ) : (
                            <Box sx={{ mt: 2 }}>
                              {step.status === "خطایی رخ داد." ? (
                                <Typography color="error" variant="body1">
                                  عدم ادامه به دلیل بروز خطا در این مرحله
                                </Typography>
                              ) : (
                                <Typography>{step.status}</Typography>
                              )}
                            </Box>
                          )}
                        </StepContent>
                      </Step>
                    ))}
                  </Stepper>
                ) : (
                  <NoDataContainer />
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default InitializePage;
